export default __webpack_public_path__ + "static/media/bebe-dino.d8be28c6.png";